import { useMemo } from 'react';
import { useServiceMode } from './useServiceMode';
import type { RestaurantPublicDTO } from '../dto/restaurant.dto';

export const useSelectedMode = (restData: RestaurantPublicDTO | null): 'LOCAL' | 'DELIVERY' => {
  const urlMode = useServiceMode();

  return useMemo<'LOCAL' | 'DELIVERY'>(() => {
    const url = urlMode === 'DELIVERY' ? 'DELIVERY' : 'LOCAL';
    if (!restData?.service_mode) return url;
    if (restData.service_mode === 'both') return url;
    if (restData.service_mode === 'delivery') return 'DELIVERY';
    return 'LOCAL';
  }, [restData?.service_mode, urlMode]);
};
